module.exports = __webpack_public_path__ + "static/media/lonicarroll-IG.67d7386b.PNG";